/**
 * @generated SignedSource<<538a9f15b4598859e642453075a9eb44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartRbGameInput = {
  bet: number;
  betColor: string;
  currency: string;
  gameId: string;
  seed: string;
  strength: number;
  virtualId: number;
};
export type rbStartRbGameMutation$variables = {
  input: StartRbGameInput;
};
export type rbStartRbGameMutation$data = {
  readonly startRbGame: {
    readonly game: {
      readonly state: string;
      readonly gameId: string;
      readonly serverSeed: string | null;
      readonly serverSeedHash: string;
      readonly currency: string | null;
      readonly virtualId: number | null;
      readonly finalShuffle: string | null;
      readonly finalShuffleHash: string | null;
      readonly result: boolean | null;
      readonly bet: number | null;
      readonly betColor: string | null;
    };
  } | null;
};
export type rbStartRbGameMutation = {
  variables: rbStartRbGameMutation$variables;
  response: rbStartRbGameMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartRbGamePayload",
    "kind": "LinkedField",
    "name": "startRbGame",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RbGame",
        "kind": "LinkedField",
        "name": "game",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gameId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serverSeed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serverSeedHash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "virtualId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finalShuffle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finalShuffleHash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "result",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bet",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rbStartRbGameMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rbStartRbGameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3829e26b138d73f9b1808988f059082",
    "id": null,
    "metadata": {},
    "name": "rbStartRbGameMutation",
    "operationKind": "mutation",
    "text": "mutation rbStartRbGameMutation(\n  $input: StartRbGameInput!\n) {\n  startRbGame(input: $input) {\n    game {\n      state\n      gameId\n      serverSeed\n      serverSeedHash\n      currency\n      virtualId\n      finalShuffle\n      finalShuffleHash\n      result\n      bet\n      betColor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae14d36dd71e704b3b2710f8e4f64b86";

export default node;
